module.exports = __webpack_public_path__ + "static/media/uluch.04134f77.jpg";